/* eslint-disable max-len */
export default {
    tooltip: 'Füllen Sie das Formular aus, um das E-Book herunterzuladen.',
    form: {
        title: 'Füllen Sie das Formular aus um das E-Book herunterzuladen',
        placeholder: {
            name: 'Vorname',
            surname: 'Nachname',
            email: 'Ihre geschäftliche E-Mail-Adresse',
            company: 'Unternehmen'
        },
        label: {
            checkbox: 'Die Daten werden von Sagiton Sp. z o.o. verwaltet; sie wurden freiwillig zur Verfügung gestellt und werden vom Administrator gemäß dem Gesetz über den Schutz personenbezogener Daten vom 29. August 1997 (Gesetzblatt 2002, Nr. 101, Pos. 926, in der geänderten Fassung) für Marketingzwecke, Verkauf von Produkten und Dienstleistungen von Sagiton Sp.z o.o. verarbeitet. Ich bin über das Recht auf Zugang zu meinen Daten, deren Berichtigung und das Recht, jederzeit ihrer Verarbeitung zu widersprechen, informiert worden.',
            checkbox2: 'Ich bin damit einverstanden, dass ich von Sagiton Sp. z o.o. kommerzielle Informationen per E-Mail erhalte.',
            button: 'E-Book kostenlos herunterladen',
            refresh: 'Neu Laden'
        }
    },
    footer: {
        title: 'Interessiert Sie eine umfassende Lösung <br/> zur Sicherheit der von Ihnene gesammelten Daten?',
        button: 'Lernen Sie unser Angebot kennen'
    },
    download: {
        text: 'Danke, dass Sie das Formular ausgefüllt haben. Wir haben einen Link an die von Ihnen angegebene E-Mail-Adresse gesendet, unter dem Sie das E-Book herunterladen können.'
    },
    list: [{
        id: 'gdpr_all_about',
        slug: 'alles-uber-die-dsgvo',
        header: {
            title: 'Kostenloses E-Book herunterladen',
            subtitle: 'Alles, was Sie über die DSGVO wissen müssen',
            cover: {
                image: 'gdpr-all-about-cover-de.jpg',
                alt: 'Kostenloses E-Book herunterladen - Alles, was Sie über die DSGVO wissen müssen'
            }
        },
        content: {
            title: 'In unserem Leitfaden erfahren Sie:',
            list: [
                'Betrifft die DSGVO Sie oder Ihr Unternehmen?',
                'Welche Daten werden geschützt und gibt es Daten, die von der Verarbeitung ausgeschlossen sind?',
                'Wie hoch sind die Strafen für eine unsachgemäße Datenverarbeitung, die Ihr Unternehmen bekommen kann?',
                'Und am wichtigsten: wie können Sie im Fall einer möglichen Kontrolle beweisen, dass Sie Ihre Daten gut sichern?'
            ]
        }
    }, {
        id: 'gdpr_for_marketing',
        slug: 'dsgvo-im-marketing',
        header: {
            title: 'Kostenloses E-Book herunterladen',
            subtitle: 'DSGVO-konformes Marketing',
            cover: {
                image: 'gdpr-for-marketing-cover-de.png',
                alt: 'Kostenloses E-Book herunterladen - DSGVO-konformes Marketing'
            }
        },
        content: {
            title: 'In unserem Leitfaden erfahren Sie:',
            list: [
                'Wie führt man einen Profiling-Prozess gemäß der DSGVO durch?',
                'Wie sollte die Einwilligung in die Verarbeitung personenbezogener Daten aussehen?',
                'Wie kann die Marketingabteilung Informationen schützen?',
                'Sie lernen auch fünf Prinzipien für die Zusammenarbeit zwischen der Marketing- und Sicherheitsabteilung kennen'
            ]
        }
    }, {
        id: 'views_on_cybersecurity',
        slug: 'perspektiven-auf-cyber-sicherheit',
        header: {
            title: 'Experten-Ratgeber',
            subtitle: 'drei Perspektiven auf Cyber-Sicherheit',
            cover: {
                image: 'views-on-cybersecurity-cover-de.png',
                alt: 'Download free ebook - Three views on cybersecurity'
            }
        },
        content: {
            title: 'Von unserem E-book erfahren Sie:',
            list: [
                'welche Daten im Unternehmen gesichert werden sollten,',
                'wie Cyber-Kriminelle handeln und wer zum Opfer fallen kann,',
                'sind Unternehmen sich ihrer eigenen Schwächen bewusst und dass sich an die Bestimmungen der DSGVO anpassen müssen,',
                'was ist ein systemischer Sicherheitsansatz.'
            ]
        }
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/de/ebook.js